import { Component } from "@angular/core";

@Component({
  selector: "app-logo-cnet-5-stars",
  templateUrl: "logo-cnet-5-stars.component.html",
})
export class LogoCnet5StarsComponent {}
